import React from 'react'
import Logo from '../../components/logo'

const AuthLayout = ({
  children,
}) => {
  return (
    <div className='bg-blue'>
      {children}
    </div>
  )
}

export default AuthLayout
